(function ($) {
  Drupal.behaviors.supercatProductLayoutV2 = {
    attached: false,
    attach: function (context) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
      var $template = $('.js-supercat-container', context);
      var $header = $('.js-supercat-header', $template)
      var $productGrid = $('.js-supercat-grid', $template);
      var $vatDisclaimer = $('.js-vat-disclaimer', context);

      if ($productGrid.find('.js-product-grid--carousel').length !== 0) {
        $header.removeClass('sticky-header');
      }

      if ($vatDisclaimer.length > 1) {
        $vatDisclaimer.slice(1).hide();
      }
    }
  };
})(jQuery);
